<script>
  export let ref = null;
  const panel = true;
</script>

<div class:panel bind:this={ref} {...$$props}>
  <slot />
</div>

<style lang="scss" src="./panel.scss"></style>
